var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 9C0.875 4.5142 4.5142 0.875 9 0.875C13.4858 0.875 17.125 4.5142 17.125 9C17.125 13.4858 13.4858 17.125 9 17.125C4.5142 17.125 0.875 13.4858 0.875 9ZM9 2.125C5.20455 2.125 2.125 5.20455 2.125 9C2.125 12.7954 5.20455 15.875 9 15.875C12.7954 15.875 15.875 12.7954 15.875 9C15.875 5.20455 12.7954 2.125 9 2.125Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80806 6.99556C5.05214 6.75148 5.44786 6.75148 5.69194 6.99556L9 10.3036L12.3081 6.99556C12.5521 6.75148 12.9479 6.75148 13.1919 6.99556C13.436 7.23964 13.436 7.63536 13.1919 7.87944L9.44194 11.6294C9.19786 11.8735 8.80214 11.8735 8.55806 11.6294L4.80806 7.87944C4.56398 7.63536 4.56398 7.23964 4.80806 6.99556Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashDropDown);
export default __webpack_public_path__ + "static/media/WashDropDown.bddd9f3e.svg";
export { ForwardRef as ReactComponent };